import { BUILD_CONFIGS, BuildBrand, DEFAULT_BUILD_BRAND } from 'config/buildConfig';
import { THEME_TOKENS } from 'config/theme';

export type BuildProfile = (typeof BUILD_CONFIGS)[BuildBrand] & {
  theme: (typeof THEME_TOKENS)[BuildBrand];
};

const resolveBrandFromEnv = (): BuildBrand | null => {
  const siteNameRaw = (process.env.REACT_APP_SITE_NAME || '').trim().toLowerCase();
  if (siteNameRaw.includes('chadebb') || siteNameRaw.includes('chadebb.com')) {
    return 'chadebb';
  }
  if (siteNameRaw.includes('chadebebe') || siteNameRaw.includes('cha de bebe')) {
    return 'chadebebe';
  }
  if (siteNameRaw.includes('listacasamento') || siteNameRaw.includes('lista casamento')) {
    return 'listacasamento';
  }
  if (siteNameRaw.includes('presentear')) {
    return 'presentear';
  }

  return null;
};

const resolveBrand = (): BuildBrand => {
  return resolveBrandFromEnv() || DEFAULT_BUILD_BRAND;
};

const brand = resolveBrand();

export const BUILD_PROFILE: BuildProfile = {
  ...BUILD_CONFIGS[brand],
  theme: THEME_TOKENS[BUILD_CONFIGS[brand].themeKey],
};

export const DEMO_LIST_SLUG = BUILD_PROFILE.demoListSlug;
export const DEMO_LIST_PATH = `/lista/${DEMO_LIST_SLUG}`;
